import React from "react";
import { Helmet } from "react-helmet-async";

type PageMetaProps = {
    title: string;
    description: string;
    path: string;
    image?: string;
    noIndex?: boolean;
};

const SITE_URL = "https://plumme.ru";

const DEFAULT_IMAGE = "https://cdn.plumme.ru/static/background/Welcom_Screen3.jpg";

export const PageMeta: React.FC<PageMetaProps> = ({title, description, path, image = DEFAULT_IMAGE, noIndex = false,}) => {
    const normalizedPath = path === "/" ? "/" : `/${path.replace(/^\/|\/$/g, "")}`;
    const canonicalUrl = `${SITE_URL}${normalizedPath}`;
    const imageUrl = "https://plumme.ru/og_image.png";

    return (
        <Helmet prioritizeSeoTags>
            <title>{title}</title>

            <meta name="description" content={description}/>
            <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow"}/>

            <link rel="canonical" href={canonicalUrl}/>

            <meta property="og:type" content="website" />
            <meta property="og:locale" content="ru_RU" />
            <meta property="og:site_name" content="Plumme" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description}/>
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={imageUrl} />

            {/*<meta name="twitter:card" content="summary_large_image"/>*/}
            {/*<meta name="twitter:title" content={title} />*/}
            {/*<meta name="twitter:description" content={description}/>*/}
            {/*<meta name="twitter:image" content={image} />*/}
        </Helmet>
    );
};